<div class="whiteboard-container d-flex flex-column h-100 bg-white">
  <div class="whiteboard-header d-flex align-items-center justify-content-between p-2 border-bottom">
    <div class="d-flex align-items-center gap-2">
      <button mat-icon-button btnType="action-icon" (click)="sidenavService.toggle()" [matTooltip]="(sidenavService.isSmallOrTablet() ? 'Global.Menu' : 'Global.ToggleSidebar') | translate">
        <mat-icon>{{ sidenavService.isSmallOrTablet() ? 'menu' : 'left_panel_open' }}</mat-icon>
      </button>
    </div>

    <div class="whiteboard-toolbar-outer-wrapper" [class.has-scroll-buttons]="showScrollButtons()">
      @if (showScrollButtons()) {
        <button type="button" class="scroll-btn left-btn" mat-icon-button (mousedown)="$event.preventDefault()" (click)="scrollToolbar('left')">
          <mat-icon>chevron_left</mat-icon>
        </button>
      }

      <div class="whiteboard-commands-container" #toolbarContainer>
        @if (!readOnly) {
          <!-- Mode selectors -->
          <button mat-icon-button btnType="action-icon" (click)="mode = 'pencil'" [class.active]="mode === 'pencil'" [matTooltip]="'VideoCall.Whiteboard.Pencil' | translate">
            <mat-icon>brush</mat-icon>
          </button>
          <button mat-icon-button btnType="action-icon" (click)="mode = 'eraser'" [class.active]="mode === 'eraser'" [matTooltip]="'VideoCall.Whiteboard.Eraser' | translate">
            <mat-icon>ink_eraser</mat-icon>
          </button>
          <button mat-icon-button btnType="action-icon" (click)="mode = 'postit'" [class.active]="mode === 'postit'" [matTooltip]="'VideoCall.Whiteboard.PostIt' | translate">
            <mat-icon>note</mat-icon>
          </button>
        }
        <button mat-icon-button btnType="action-icon" (click)="mode = 'pan'" [class.active]="mode === 'pan'" [matTooltip]="'VideoCall.Whiteboard.Pan' | translate">
          <mat-icon>pan_tool</mat-icon>
        </button>

        @if (!readOnly) {
          <div class="toolbar-divider"></div>

          <button mat-icon-button btnType="action-icon" (click)="save()" [matTooltip]="'VideoCall.Whiteboard.Save' | translate">
            <mat-icon>save_alt</mat-icon>
          </button>

          @if (isEditingChunk) {
            <button mat-icon-button btnType="action-icon" (click)="saveChunkData()" [matTooltip]="'Global.Save' | translate">
              <mat-icon>save</mat-icon>
            </button>
          }

          <div class="size-dropdown">
            <button mat-icon-button btnType="action-icon" (click)="$event.preventDefault(); $event.stopPropagation(); isActive = !isActive" [matTooltip]="'VideoCall.Whiteboard.BrushSize' | translate">
              <mat-icon>line_weight</mat-icon>
            </button>
            <ul class="dropdown" [ngClass]="{ active: isActive }">
              <li class="dropdown-item" (click)="setSize(2.5)" [class.selected]="size === 2.5">
                <svg height="100%" width="100%">
                  <line x1="0" y1="50%" x2="100%" y2="50%" style="stroke-width: 2.5px" [attr.stroke]="color" />
                </svg>
              </li>
              <li class="dropdown-item" (click)="setSize(5)" [class.selected]="size === 5">
                <svg height="100%" width="100%">
                  <line x1="0" y1="50%" x2="100%" y2="50%" style="stroke-width: 5px" [attr.stroke]="color" />
                </svg>
              </li>
              <li class="dropdown-item" (click)="setSize(10)" [class.selected]="size === 10">
                <svg height="100%" width="100%">
                  <line x1="0" y1="50%" x2="100%" y2="50%" style="stroke-width: 10px" [attr.stroke]="color" />
                </svg>
              </li>
              <li class="dropdown-item" (click)="setSize(15)" [class.selected]="size === 15">
                <svg height="100%" width="100%">
                  <line x1="0" y1="50%" x2="100%" y2="50%" style="stroke-width: 15px" [attr.stroke]="color" />
                </svg>
              </li>
            </ul>
          </div>

          <button #eraseBtn mat-icon-button btnType="action-icon" (click)="erase(eraseBtn)" [matTooltip]="'VideoCall.Whiteboard.Clear' | translate">
            <mat-icon>delete</mat-icon>
          </button>
          <button mat-icon-button btnType="action-icon" (click)="undo()" [matTooltip]="'VideoCall.Whiteboard.Undo' | translate">
            <mat-icon>undo</mat-icon>
          </button>
          <button mat-icon-button btnType="action-icon" (click)="redo()" [matTooltip]="'VideoCall.Whiteboard.Redo' | translate">
            <mat-icon>redo</mat-icon>
          </button>

          <button #colorBtn mat-icon-button btnType="action-icon" (click)="openColorPicker(colorBtn)" [matTooltip]="'VideoCall.Whiteboard.Color' | translate">
            <mat-icon [style.color]="color">palette</mat-icon>
          </button>
        }
      </div>

      @if (showScrollButtons()) {
        <button type="button" class="scroll-btn right-btn" mat-icon-button (mousedown)="$event.preventDefault()" (click)="scrollToolbar('right')">
          <mat-icon>chevron_right</mat-icon>
        </button>
      }
    </div>

    <button mat-icon-button (click)="closeWhiteboard()" [matTooltip]="'Global.Close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="whiteboard-body flex-grow-1 overflow-hidden position-relative w-100 h-100">
    <div
      #zoomContainer
      #zoom="appZoomable"
      appZoomable
      [enableZoom]="true"
      [enablePan]="mode === 'pan'"
      [enableWheelZoom]="true"
      [minScale]="0.5"
      [maxScale]="3.0"
      [(zoomScale)]="zoomScale"
      class="w-100 h-100 overflow-hidden relative"
      [class.cursor-pencil]="mode === 'pencil'"
      [class.cursor-eraser]="mode === 'eraser'"
      [class.cursor-grab]="mode === 'pan' && !zoom.isDragging()"
      [class.cursor-grabbing]="mode === 'pan' && zoom.isDragging()"
      (click)="onZoomContainerClick($event, zoomContainer, zoom)"
    >
      <app-zoom-control
        class="zoom-toolbar absolute bottom-4 right-4 z-30"
        [(zoomScale)]="zoom.zoomScale"
        [minScale]="0.5"
        [maxScale]="3.0"
        (reset)="zoom.resetZoom()"
        (click)="$event.stopPropagation()"
      />

      <div class="w-100 h-100 relative">
        <app-whiteboard-part
          #whiteboardPart
          [color]="color"
          [size]="size"
          [boardID]="boardID"
          [zoomScale]="zoom.zoomScale()"
          [panX]="zoom.panX()"
          [panY]="zoom.panY()"
          [tool]="mode === 'eraser' ? 'eraser' : 'freehand'"
          [postits]="postits"
          [readOnly]="readOnly"
          [style.pointer-events]="mode === 'pan' ? 'none' : 'auto'"
          (strokeAdded)="onLocalStrokeAdded($event)"
          class="w-100 h-100"
        ></app-whiteboard-part>

        <!-- Post-its overlay layer -->
        <div
          class="post-its-layer absolute inset-0 pointer-events-none"
          [style.transform]="'translate(' + zoom.panX() + 'px, ' + zoom.panY() + 'px) scale(' + zoom.zoomScale() + ')'"
          style="transform-origin: 0 0"
        >
          @for (note of postits; track note.id) {
            <div
              class="post-it pointer-events-auto absolute"
              [style.left.px]="note.x"
              [style.top.px]="note.y"
              [style.background-color]="note.color"
              (click)="$event.stopPropagation()"
              (mousedown)="$event.stopPropagation()"
            >
              <!-- Drag Handle -->
              @if (!readOnly) {
                <div class="post-it-drag-handle" (mousedown)="startDragNote($event, note, zoom.zoomScale())" (touchstart)="startDragNoteTouch($event, note, zoom.zoomScale())">
                  <mat-icon class="drag-grip-icon">drag_indicator</mat-icon>
                </div>
              }

              <textarea
                [(ngModel)]="note.text"
                [disabled]="readOnly"
                (ngModelChange)="onPostItTextChanged(note)"
                [placeholder]="'VideoCall.Whiteboard.PostItPlaceholder' | translate"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                (touchstart)="$event.stopPropagation()"
              ></textarea>
              @if (!readOnly) {
                <button class="delete-note-btn" (click)="deletePostIt(note.id); $event.stopPropagation()" (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
